//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    cover: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    sellCount: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    showDetail() {
      this.$emit('onDetail', {
        id: this.id,
      })
    },
  },
}
